import { jsx as _jsx } from "react/jsx-runtime";
import PageBackButton from "./components/PageBackButton";
import PageBody from "./components/PageBody";
import PageFilters from "./components/PageFilters";
import PageFooter from "./components/PageFooter";
import PageHeader from "./components/PageHeader";
import PageTabs from "./components/PageTabs";
const Page = ({ children }) => {
    return _jsx("div", { className: "mb-16 min-h-full space-y-5 bg-white p-5", children: children });
};
Page.BackButton = PageBackButton;
Page.Header = PageHeader;
Page.HeaderTitle = PageHeader.Title;
Page.HeaderActions = PageHeader.Actions;
Page.Filters = PageFilters;
Page.Tabs = PageTabs;
Page.Body = PageBody;
Page.Footer = PageFooter;
export default Page;
